import { gql } from 'urql';

const BillManagerRouteQuery = gql`
  query BillManagerRoute {
    billManagerRoute {
      __typename
      route
    }
  }
`;

export default BillManagerRouteQuery;
